import { PaziaHeader } from "components/atoms/PaziaHeader/PaziaHeader";
import { PaziaButton, PaziaButtonType } from "components/atoms";
import React from "react";

interface PageHeaderButton {
  title: string;
  type?: PaziaButtonType;
  onClick: () => void;
}

interface PaziaHeaderProps {
  children: React.ReactNode;
  button?: PageHeaderButton;
  secondaryButton?: PageHeaderButton;
}
export const PageHeader = ({ children, button, secondaryButton }: PaziaHeaderProps): JSX.Element | null => {
  return (
    <div className="flex gap-4 pb-4 items-center">
      <PaziaHeader>{children}</PaziaHeader>
      {secondaryButton && <PaziaButton {...{ type: "tertiary", ...secondaryButton }} />}
      {button && <PaziaButton {...{ type: "primary", ...button }} />}
    </div>
  );
};
